import React from 'react';
import { useNavigate } from 'react-router-dom';
import OverDue from './OverDue';
import Regular from './Regular';

const SelfSummary = ({ customerInfo,labels }) => {
    const navigate = useNavigate();
    const selfData = customerInfo?.GroupDetails?.Customers?.filter(el => el.Number === customerInfo.CustomerDetails.Number);
    const customerNumber = customerInfo?.CustomerDetails?.Number;

    return (
        <>
            <div className="font-bold mt-2 text-black text-lg border-t border-r border-l bg-gray-300 p-3 rounded-t-[15px] fs-32w">
                {labels.yourLoan}
            </div>
            {selfData?.map((el, index) => {
                return (
                    <div key={index}>
                        {el.LoanHealth === "Overdue" ? 
                            <OverDue el={el} customerNumber={customerNumber} navigate={navigate} labels={labels}/> : 
                            <Regular el={el} customerNumber={customerNumber} navigate={navigate} labels={labels} />
                        }
                    </div>
                );
            })}
        </>
    );
}

export default SelfSummary;
